import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Layout } from '../components/Layout';
import { DataTable } from '../components/DataTable';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL || 'https://tecteach-server.vercel.app/api/v1';

const IntroToAIOrganizations: React.FC = () => {
  const { admin } = useAuth();
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/users/get-all-intro-to-ai-organizations?whiteLabelClientId=${admin?.whiteLabelClientId}`
        );
        setOrganizations(response.data);
      } catch (error) {
        console.error('Error fetching organizations:', error);
      } finally {
        setLoading(false);
      }
    };

    if (admin?.whiteLabelClientId) {
      fetchOrganizations();
    }
  }, [admin]);

  const columns = [
    { id: 'organizationName', label: 'Organization Name' },
    { id: 'adminEmail', label: 'Admin Email' },
    { id: 'numberOfStudents', label: 'Students' },
    {
      id: 'createdAt',
      label: 'Created Date',
      format: (value: string) => format(new Date(value), 'MMM dd, yyyy'),
    },
  ];

  return (
    <Layout>
      <Box>
        <Typography variant="h4" fontWeight={700} color="#142060" gutterBottom>
          Intro to AI Organizations
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Manage Intro to AI course organizations
        </Typography>

        <DataTable columns={columns} data={organizations} loading={loading} />
      </Box>
    </Layout>
  );
};

export default IntroToAIOrganizations;
